import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const WhiteDischargePage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for White Discharge</h1>
        <section className="mb-8">
          <p>White discharge, or leucorrhea, is a common gynecological concern in women. Our natural therapies focus on addressing the underlying causes, restoring vaginal health, and preventing recurrence through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Infections</li>
            <li>Poor hygiene</li>
            <li>Stress</li>
            <li>Uncontrolled diabetes</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Excessive vaginal discharge</li>
            <li>Itching or irritation</li>
            <li>Foul odor</li>
            <li>Lower abdominal pain</li>
            <li>Weakness or fatigue</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-infective herbs, hormone-balancing remedies, and lifestyle modifications to naturally treat white discharge. Our approach focuses on restoring vaginal health and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Restores vaginal health</li>
            <li>Reduces infection risk</li>
            <li>No harsh side effects</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain good hygiene</li>
            <li>Wear breathable cotton underwear</li>
            <li>Manage stress</li>
            <li>Eat a balanced diet</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many women notice improvement within 2-4 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for all ages?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes and promoting hygiene.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from white discharge—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default WhiteDischargePage; 